import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext.tsx';
import type { DealPromptFilters } from '../utils/types.ts';

export const useAudienceSearchTextFetch = (criteria: AllTableCriteria<DealPromptFilters>) => {
  const { useDealPromptAudienceSearchTextFetch } = useDealPromptDomainsContext();

  const { fetchDealPromptAudienceSearchText } = useDealPromptAudienceSearchTextFetch(criteria);

  return fetchDealPromptAudienceSearchText;
};
